import { ApproveRequiredTypesEnum } from 'APIPackage/KnmModule/enums/ApproveRequiredTypesEnum';

import { IApproveRequiredSelectOption } from '../interfaces/IApproveRequiredSelectOption';
import { IAdminSetting } from '../../../APIPackage/AdminModule/interfaces/IAdminSetting';
import { isLaterThanAdminSetting } from '../../../CorePackage/MainModule/validators/isLaterThanAdminSetting';
import { AdminSettingCodesEnum } from '../../../APIPackage/AdminModule/enums/AdminSettingCodesEnum';

export const approveRequiredSelectOption: IApproveRequiredSelectOption = {
  id: ApproveRequiredTypesEnum.REQUIRED,
  label: 'Требует согласования',
  value: ApproveRequiredTypesEnum.REQUIRED,
  agreementValue: 'Требуется',
};

export const notApproveRequiredSelectOption: IApproveRequiredSelectOption = {
  id: ApproveRequiredTypesEnum.NON_REQUIRED,
  label: 'Не требует согласования',
  value: ApproveRequiredTypesEnum.NON_REQUIRED,
  agreementValue: 'Не требуется',
};

export const notificationApproveRequiredSelectOption: IApproveRequiredSelectOption = {
  id: ApproveRequiredTypesEnum.PROMPTLY,
  label: 'Незамедлительное КНМ с уведомлением прокурора',
  value: ApproveRequiredTypesEnum.PROMPTLY,
  agreementValue: 'Уведомление',
};

export const approveRequiredSelectOptions: IApproveRequiredSelectOption[] = [
  notApproveRequiredSelectOption,
  notificationApproveRequiredSelectOption,
  approveRequiredSelectOption,
];

export const getApproveRequiredSelectOptionsByCreated = (
  created: string | undefined | null,
  settings: IAdminSetting[] | undefined,
): IApproveRequiredSelectOption[] => {
  const isUseNewLabelForNotificationApproveRequired = isLaterThanAdminSetting(
    created,
    settings,
    AdminSettingCodesEnum.LABEL_OF_APPROVE_REQUIRED_FIELD_4_1_2_STARTS_FROM,
  );

  if (isUseNewLabelForNotificationApproveRequired) {
    return approveRequiredSelectOptions;
  }

  return approveRequiredSelectOptions.map(item => {
    if (item.id === ApproveRequiredTypesEnum.PROMPTLY) {
      return { ...notificationApproveRequiredSelectOption, label: 'Незамедлительная проверка, ст.66' };
    }

    return item;
  });
};

export const approveRequiredSelectOptionsForFilter: IApproveRequiredSelectOption[] = [
  {
    id: ApproveRequiredTypesEnum.NON_REQUIRED,
    label: 'Не требует согласования',
    value: ApproveRequiredTypesEnum.NON_REQUIRED,
  },
  {
    id: ApproveRequiredTypesEnum.PROMPTLY,
    label: 'Незамедлительное КНМ с уведомлением прокурора',
    value: ApproveRequiredTypesEnum.PROMPTLY,
  },
  approveRequiredSelectOption,
];
